uniform vec2 resolution;
uniform float time;
varying vec2 vUv;

#pragma glslify: ease = require(glsl-easings/circular-in-out)

float remap(float x, float a, float b, float c, float d) {
    return c + (x - a) * (d - c) / (b - a);
}

void main() {
    // vec2 st = gl_FragCoord.xy / resolution.xy;
    // gl_FragColor = vec4(st.x, st.y, 1.0, 1.0);
    vec2 uv = vUv - 0.5;
    vec2 p = uv * resolution;
    float v = 0.0;

    vec2 circleP = p + vec2(0.0, -30.0);
    float circle = 1.0 - clamp(length(p), 0.0, 200.0) / 200.0;
    circle = ease(circle);
    //circle = clamp(1.0 - circle * 0.01, 0.0, 1.0);
    v = max(v, circle);

    vec3 aColor = vec3(0.0);
    vec3 bColor = vec3(0.0, 0.95, 1.0);

    vec3 outColor = mix(aColor, bColor, circle);

    gl_FragColor = vec4(outColor, 1.0);

}